<template>
	<div
		:class="contentClass"
		:aria-expanded="isOpen"
		role="region"
		:aria-label="title"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
  props: {
		id: {
      type: String,
    },
		title: {
      type: String,
			required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },
	computed:{
		contentClass(){
			return `c-collapsible-container__content ${this.isOpen ? 'c-collapsible-container__content--open' : 'c-collapsible-container__content--closed'}`
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/collapsible-container/CollapsibleContainerContent.vue